import * as React from "react";
import { useMemo } from "react";
import SearchExecutorsContext from "views/components/contexts/SearchExecutorsContext";
import SearchPage from "views/pages/SearchPage";
import Search from "views/logic/search/Search";
import View from "views/logic/views/View";
import SearchResult from "views/logic/SearchResult";
import SearchMetadata from "views/logic/search/SearchMetadata";
const searchMetadata = SearchMetadata.empty();
const StaticSearch = ({ searchJson, viewJson, searchJobResult }) => {
  const view = useMemo(() => {
    const search = Search.fromJSON(searchJson);
    return View.fromJSON(viewJson).toBuilder().search(search).build();
  }, [searchJson, viewJson]);
  const searchResult = useMemo(
    () => ({
      result: new SearchResult(searchJobResult),
      widgetMapping: view.widgetMapping
    }),
    [searchJobResult, view.widgetMapping]
  );
  const searchExecutors = useMemo(
    () => ({
      execute: async () => searchResult,
      parse: async () => searchMetadata,
      resultMapper: (result) => result,
      cancelJob: () => Promise.resolve(null),
      startJob: () => Promise.resolve({ asyncSearchId: "1nbmnbmnb1", nodeId: "222" }),
      executeJobResult: () => Promise.resolve(searchResult)
    }),
    [searchResult]
  );
  return /* @__PURE__ */ React.createElement(SearchExecutorsContext.Provider, { value: searchExecutors }, /* @__PURE__ */ React.createElement(SearchPage, { view: Promise.resolve(view), isNew: false, searchResult, skipDocumentTitle: true }));
};
export default StaticSearch;
